import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getSystemConfigsDataTable,
  getSystemConfigById,
  editSystemConfig,
} from './thunks';
import { SystemConfigsState } from './types';

export const name = 'systemConfigs';

const initialState: SystemConfigsState = {
  dataTable: {
    data: null,
    status: 'idle',
  },
  systemConfigById: {
    data: null,
    status: 'idle',
  },
  editSystemConfig: {
    data: null,
    status: 'idle',
  },
};

export const getSystemConfigsDataTableAsync = createAsyncThunk(
  name + '/getSystemConfigsDataTable',
  getSystemConfigsDataTable
);

export const getSystemConfigByIdAsync = createAsyncThunk(
  name + '/getSystemConfigById',
  getSystemConfigById
);

export const editSystemConfigAsync = createAsyncThunk(
  name + '/editSystemConfig',
  editSystemConfig
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSystemConfigsDataTableAsync.pending, (state) => {
        state.dataTable.status = 'loading';
      })
      .addCase(getSystemConfigsDataTableAsync.fulfilled, (state, action) => {
        state.dataTable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getSystemConfigsDataTableAsync.rejected, (state) => {
        state.dataTable.status = 'failed';
      })
      .addCase(getSystemConfigByIdAsync.pending, (state) => {
        state.systemConfigById.status = 'loading';
      })
      .addCase(getSystemConfigByIdAsync.fulfilled, (state, action) => {
        state.systemConfigById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getSystemConfigByIdAsync.rejected, (state) => {
        state.systemConfigById.status = 'failed';
      })
      .addCase(editSystemConfigAsync.pending, (state) => {
        state.editSystemConfig.status = 'loading';
      })
      .addCase(editSystemConfigAsync.fulfilled, (state, action) => {
        state.editSystemConfig = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(editSystemConfigAsync.rejected, (state) => {
        state.editSystemConfig.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
